//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import * as moment from "moment";

// Create Document Component
export default function CiprianReportPDF({ states, date, setStates,reportId}) {
  const { pdfData } = states;
  let transactions = pdfData?.ciprian;
  let colwidth
  // Create styles
  // console.log(reportId,"hhhhh",pdfData?.ciprian)

  switch (reportId) {
    case 1:
      transactions= pdfData?.ciprian?.map((t) => [
      {
        value: t?.Category?t?.Category:" ",
      },
      {
        value: t?.Bronze_Consented?t?.Bronze_Consented:" ",
      },
      {
        value: t?.Bronze_UnConsented?t?.Bronze_UnConsented:" ",
      },
      {
        value: t?.NonBronze_Consented?t?.NonBronze_Consented:" ",
      },
      {
        value: t?.NonBronze_UnConsented?t?.NonBronze_UnConsented:" ",
      },
      {
        value: t?.Total?t?.Total:" ",
      }
    ]);
    
      break;
    case 2:
      transactions= pdfData?.ciprian?.map((t) => [
        {
          value: t?.Category?t?.Category:" ",
        },
        {
          value: t?.Bronze_Level?t?.Bronze_Level:" ",
        },
        {
          value: t?.Moved_Higher?t?.Moved_Higher:" ",
        },
        {
          value: t?._Movement?t?._Movement:" ",
        }
      ]);
    break;
    case 3:
      transactions= pdfData?.ciprian?.map((t) => [
        {
          value: t?.SalesCategory?t?.SalesCategory:" ",
        },
        {
          value: t?.Bronze_Consented?t?.Bronze_Consented:" ",
        },
        {
          value: t?.Bronze_UnConsented?t?.Bronze_UnConsented:" ",
        },
        {
          value: t?.NonBronze_Consented?t?.NonBronze_Consented:" ",
        },
        {
          value: t?.NonBronze_UnConsented?t?.NonBronze_UnConsented:" ",
        }
      ]);
      break;
    case 4:
      transactions= pdfData?.ciprian?.map((t) => [
        {
          value: t?.Category?t?.Category:" ",
        },
        {
          value: t?.total_points?t?.total_points:" ",
        },
        {
          value: t?.Points_to_be_Expired_Month_1?t?.Points_to_be_Expired_Month_1:" ",
        },
        {
          value: t?.Points_to_be_Expired_Month_2?t?.Points_to_be_Expired_Month_2:" ",
        },
        {
          value: t?.Points_to_be_Expired_Month_3?t?.Points_to_be_Expired_Month_3:" ",
        },
        {
          value: t?.Points_to_be_Expired_Month_4?t?.Points_to_be_Expired_Month_4:" ",
        },
        {
          value: t?.Points_to_be_Expired_Month_5?t?.Points_to_be_Expired_Month_5:" ",
        },
        {
          value: t?.Points_to_be_Expired_Month_6?t?.Points_to_be_Expired_Month_6:" ",
        },
        {
          value: t?.Points_to_be_Expired_Month_7?t?.Points_to_be_Expired_Month_7:" ",
        },
        {
          value: t?.Points_to_be_Expired_Month_8?t?.Points_to_be_Expired_Month_8:" ",
        },
        {
          value: t?.Points_to_be_Expired_Month_9?t?.Points_to_be_Expired_Month_9:" ",
        },
        {
          value: t?.Points_to_be_Expired_Month_10?t?.Points_to_be_Expired_Month_10:" ",
        },
        {
          value: t?.Points_to_be_Expired_Month_11?t?.Points_to_be_Expired_Month_11:" ",
        },
        {
          value: t?.Points_to_be_Expired_Month_12?t?.Points_to_be_Expired_Month_12:" ",
        },
      ]);
      break;
  }
  let coulumns
  switch (reportId) {
    case 1:
    coulumns= [
        { title: "Category"},
        { title: "Bronze-Consented"},
        { title: "Bronze-UnConsented"},
        { title: "NonBronze-Consented"},
        { title: "NonBronze-UnConsented"},
        { title: "Total"}
      ];
      colwidth=100/6;
      break;
    case 2:
    coulumns= [
      { title: "Category"},
      { title: "Bronze Level"},
      { title: "Moved Higher"},
      { title: "%Movement"}
    ];
    colwidth=100/4;
    break;
    case 3:
      coulumns= [
        { title: "SalesCategory"},
        { title: "Bronze-Consented"},
        { title: "Bronze-UnConsented"},
        { title: "NonBronze-Consented"},
        { title: "NonBronze-UnConsented"}
      ];
      colwidth=100/5;
      break;
    case 4:
      coulumns= [
        { title: "Category"},
        { title: "total_points"},
        { title: "Points to be Expired Month 1"},
        { title: "Points to be Expired Month 2"},
        { title: "Points to be Expired Month 3"},
        { title: "Points to be Expired Month 4"},
        { title: "Points to be Expired Month 5"},
        { title: "Points to be Expired Month 6"},
        { title: "Points to be Expired Month 7"},
        { title: "Points to be Expired Month 8"},
        { title: "Points to be Expired Month 9"},
        { title: "Points to be Expired Month 10"},
        { title: "Points to be Expired Month 11"},
        { title: "Points to be Expired Month 12"}

      ]
      colwidth=100/14;
      break;
  }
  const styles = StyleSheet.create({
    body: {
      padding: 10,
    },
    table1: {
      display: "table",
      width: "auto",
      borderStyle: "solid",
      borderColor: "#000",
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
    },
    table2: {
      display: "table",
      width: "auto",
      borderStyle: "solid",
      borderColor: "#000",
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
      marginBottom: 10,
    },
    table3: {
      display: "table",
      width: "auto",
      borderStyle: "solid",
      borderColor: "#000",
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
    },
    tableRow: {
      margin: "auto",
      flexDirection: "row",
    },
    table1ColHeader: {
      backgroundColor: "#315496",
      color: "#ffffff",
      width: "100%",
      borderStyle: "solid",
      borderColor: "#000",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    table2ColHeader: {
      backgroundColor: "#ffffff",
      color: "#000",
      width: "16.66%",
      borderStyle: "solid",
      borderColor: "#000",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    table2Col: {
      width: "16.66%",
      borderStyle: "solid",
      borderColor: "#000",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableColHeader: {
      backgroundColor: "#315496",
      color: "#ffffff",
      width: `${colwidth}%`,
      borderStyle: "solid",
      borderColor: "#000",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableCol: {
      width: `${colwidth}%`,
      borderStyle: "solid",
      borderColor: "#000",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    table1CellHeader: {
      margin: "auto",
      margin: 5,
      fontSize: 12,
      fontWeight: 500,
      textAlign: "center",
    },
    tableCellHeader: {
      margin: "auto",
      margin: 5,
      fontSize: 12,
      fontWeight: 500,
    },
    tableCell: {
      margin: "auto",
      margin: 5,
      fontSize: 7,
    },
  });
  // console.log(transactions,"jjjjjj")
  return (
    <Document
      onRender={() => {
        document.getElementById("download-pdf").click();
      }}
    >
      <Page style={styles.body}>

        <View style={styles.table3}>
    
          <View style={styles.tableRow}>
          {coulumns.map((e)=>(
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>{e?.title}</Text>
            </View>
          ))}
          </View>
          {transactions?.map((t, i) => (
         <View style={styles.tableRow} key={i}>
            {t.map((r,j)=>( 
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{r?.value}</Text>
              </View>
             ))}
            </View>
           
          ))}
        </View>
      </Page>
    </Document>
  );
}

// export default MyDocument;
